/* eslint-disable no-console */
import { EventEmitter } from 'events';
import { Logger } from './logger';

export class LogManager extends EventEmitter {
    private options: LogOptions = {
        minLevels: {
        '': 'info'
        }
    };

    // Prevent the console logger from being added twice
    private consoleLoggerRegistered = false;

    configure(options: LogOptions): LogManager {
        this.options = Object.assign({}, this.options, options);
        return this;
    }

    getLogger(module: string): Logger {
        let minLevel = 'none';
        let match = '';

        for (const key in this.options.minLevels) {
        if (module.startsWith(key) && key.length >= match.length) {
            minLevel = this.options.minLevels[key];
            match = key;
        }
        }

        return new Logger(this, module, minLevel);
    }

    onLogEntry(listener: (logEntry: LogEntry) => void): LogManager {
        super.on('log', listener);

        return this;
    }

    registerConsoleLogger(): LogManager {
        if (this.consoleLoggerRegistered) return this;

        this.onLogEntry((logEntry) => {
            let msg: string;
            switch (logEntry.level) {
                case 'trace':
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.trace(msg);
                    break;
                case 'debug':
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.debug(msg);
                    break;
                case 'info':
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.info(msg);
                    break;
                case 'warn':
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.warn(msg);
                    break;
                case 'error':
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.error(msg);
                    break;
                default:
                    msg = `${logEntry.location} [${logEntry.module}] ${logEntry.message}`;
                    console.log(`{${logEntry.level}} ${msg}`);
            }
        });

        this.consoleLoggerRegistered = true;
        return this;
    }
}

export interface LogEntry {
    level: string;
    module: string;
    location?: string;
    message: string;
}

export interface LogOptions {
    minLevels: { [module: string]: string };
}

export const logging = new LogManager()
    .configure({
        minLevels: {
            '': 'info',
            'core': 'warn'
        }
    })
    .registerConsoleLogger();
